import { ReportJWTResp } from '@monetize/types/app';
import { apiPost } from './axios';

export async function doGetReportingJWT(): Promise<ReportJWTResp> {
  const res = await apiPost<ReportJWTResp>(`/api/reporting/jwt`);
  return res.data;
}
